import { TranslationObject } from '@ngx-translate/core';

const pt: TranslationObject = {
  pt: 'Português',
  en: 'Inglês',
  app: {
    title: 'Revisão de Segurança Pré-Inicialização',
    forms: {
      ok: 'Ok',
      cancel: 'Cancelar',
      continue: 'Continuar',
      selectAll: 'Selecionar Tudo',
      save: 'Salvar',
      labels: {
        businessUnit: 'Unidade de Negócios',
        organization: 'Organização',
        user: 'Usuário',
        name: 'Nome',
        description: 'Descrição',
        displayRichEditor: 'Exibir editor de texto enriquecido',
        statusOptions: {
          draft: 'Draft',
          initiated: 'Initiated',
          inProgress: 'In Progress',
          completed: 'Completed',
          pendingApproval: 'Pending Approval',
          approved: 'Approved',
          closed: 'Closed',
        },
        placeHolderDescription: 'Digite uma descrição',
        placeHolderReviewType: 'Selecione um tipo de revisão',
        mandatory: 'Obrigatório',
        isActive: 'Ativo',
      },
      categories: {
        placeholders: {
          categoryName: 'Nome da categoria',
        },
      },
      create: 'Criar',
      unsavedChangesWarning:
        'Alterações não salvas foram detectadas. Se você sair desta página, as modificações que você fez serão perdidas.<br>Você quer continuar?',
      validation: {
        required: '{{controlName}} é obrigatório',
        invalidEmail: 'Por favor, insira um endereço de e-mail válido',
      },
    },
    warnings: {
      removeOwnAdminRights:
        'Você removeu seus direitos de administrador. Por favor, atualize a página para evitar mau funcionamento.',

      removeOwnAccess: 'Você removeu seu acesso. Por favor, atualize a página para evitar mau funcionamento.',
    },
  },
  header: {
    support: 'Suporte',
    userGuide: 'Guia do Usuário',
  },
  navigation: {
    pssrs: '{{pssrTitle}}s',
    projects: 'Projetos',
    actionsItems: 'Itens de Ação',
    administration: 'Administração',
    hierarchyManagement: 'Gerenciamento de Hierarquia',
    businessUnits: 'Unidade de Negócios',
    organizations: 'Organização',
    facilityHierarchy: 'Hierarquia de instalações',
    accessManagement: 'Gerenciamento de Acesso',
    organizationUsers: 'Usuários',
    buAdmins: 'Administradores de usuários',
    userGroups: 'Grupos de usuários de itens de ação',
    systemAdmins: 'Administradores do sistema',
    pssrConfiguration: 'Configuração PSSR',
    templates: 'Listas de verificação PSSR',
    categories: 'Categorias da unidade de negócio',
  },
  functionalReviewList: {
    title: 'Revisão Funcional',
    noFunctionalReview: 'Sem revisão funcional',
    id: 'ID',
    code: 'Código',
    question: 'Pergunta',
    answer: 'Resposta',
    comment: 'Comentário',
    updatedBy: 'Atualizado por',
    updatedDate: 'Data de Atualização',
    createNewFunctionalReview: 'criar nova revisão funcional',
    reviewType: 'Tipo de Revisão',
    addQuestion: 'Adicionar Pergunta',
    description: 'Descrição',
    subSection: 'Subseção',
    clearAnswer: 'Limpar Resposta',
    deleteQuestion: 'Excluir Pergunta',
    deleteQuestionTitle: 'Excluir Pergunta',
    confirmDeleteQuestion:
      '<span>Tem certeza de que deseja excluir esta pergunta?</span><br><br><span><b>Pergunta:</b> {{ description }}</span>',
    generateReport: 'Gerar Relatório',
    completeReview: 'Concluir Revisão',
    generateSuccessMessage: 'Relatório gerado com sucesso',
    reviewSuccessMessage: 'Revisão Funcional concluída com sucesso',
  },
  admin: {
    sysAdminList: {
      title: 'Administradores do Sistema',
      addSysAdmin: 'adicionar administrador do sistema',
      fullName: 'nome completo',
      disabled: 'Desabilitado',
      email: 'e-mail',
      dialogs: {
        removeAccessHeader: 'Confirmação',
        removeAccessMessage:
          'Tem certeza de que deseja remover o acesso de administrador do sistema para: [{{firstName}} {{lastName}}]?',
      },
    },
    businessUnitLists: {
      title: 'Unidade de Negócios',
      addBusinessUnit: 'adicionar unidade de negócio',
      tableTitle: 'Unidade de Negócios',
    },
    businessUnitCreate: {
      title: 'Criar Unidade de Negócios',
    },
    businessUnitEdit: {
      title: 'Editar Unidade de Negócios',
    },
    businessUnitForm: {
      sections: {
        supportInformation: {
          titleSupport: 'Informações de Suporte',
          name: 'Nome',
          businessUnitSupportInfo: 'Informações de Suporte da Unidade de Negócios',
          businessUnitSupportInfoDescription: 'Esta informação será exibida na página de suporte',
          displayRichEditor: 'xxibir editor rico',
        },
        approvalForAccess: {
          titleApproval: 'Aprovação para Acesso',
          userNeedsBuAdmin: 'O usuário precisa de um administrador da unidade de negócios para conceder acesso',
          userGetsInstantAccess: 'O usuário terá acesso instantâneo',
        },
        labels: {
          titleLabels: 'Etiquetas',
          hierarchyLabel1: 'Etiqueta de Hierarquia 1',
          hierarchyLabel2: 'Etiqueta de Hierarquia 2',
          hierarchyLabel3: 'Etiqueta de Hierarquia 3',
          pssrLabel: 'Etiqueta PSSR',
          organizationLabel: 'Etiqueta de Organização',
          eventNameLabel: 'Etiqueta de Nome de Evento',
          p3: 'P3',
          p4: 'P4',
          p5: 'P5',
          placeholderDefault: 'o valor padrão é \'projeto\'',
          show: 'mostrar',
        },
        pssrConfigurations: {
          titleConfigurations: 'Configurações PSSR',
          stagnantPssrInterval: 'Intervalo de PSSR Estagnado',
          instructions: 'Instruções',
          instructionsDescription: 'Instruções gerais estagnadas para PSSR',
          showProject: 'Deseja mostrar Projeto?',
          projectDisplayType: 'Como deseja exibir Projeto?',
          dropdown: 'lista suspensa',
          input: 'entrada',
          showKms: 'Deseja mostrar KMS? Um botão "obter do KMS" será exibido ao criar um novo PSSR.',
          showQaqcModule: 'Deseja mostrar o Módulo QAQC no Projeto? Requer que o projeto esteja habilitado.',
          showWetSignatureApproval:
            'Deseja permitir uma assinatura molhada do PSSR? Isso permite que o Representante de Operações aprove o PSSR em status de aprovação pendente. O botão diz "aprovar com assinatura molhada".',
          pssrTypesToShow: 'Quais Tipos de PSSR deseja mostrar?',
          ccc: 'CCC',
          factory: 'Fábrica',
          moc: 'MOC',
          nonMoc: 'NÃO-MOC',
          orr: 'ORR',
          pfsr: 'PFSR',
          test: 'Teste',
          showNaResponse:
            'Deseja permitir que os usuários respondam N/A? Se selecionar não, um comentário ou item de ação será necessário para ser considerado concluído.',
          sendScheduledEmail:
            'Deseja enviar um e-mail agendado todas as segundas-feiras às 8h00 CST para usuários com itens de ação pendentes?',
          showConstructionComplete:
            'Deseja mostrar o Certificado de Construção Completa (CCC) para alguns cabeçalhos/títulos/etiquetas?',
          showOperationReadiness:
            'Deseja mostrar a Revisão de Prontidão Operacional (ORR) para alguns cabeçalhos/títulos/etiquetas?',
          showVerbalApproval:
            'Deseja mostrar aprovação verbal? Isso mostra uma entrada no aplicativo móvel para escrever manualmente quem está aprovando. Isso não causa nenhuma ação e pode ser feito pelo líder ou aprovador.',
          allowLeadToDelete:
            'Deseja permitir que o líder exclua perguntas para um PSSR em status de rascunho ou iniciado?',
          allowTeamMemberActions:
            'Deseja permitir que qualquer membro da equipe responda perguntas, assine perguntas e crie itens de ação até a aprovação?',
          restrictMocWo:
            'Deseja restringir o número do projeto MOCWO? Se selecionar "sim", MOC e WO são necessários para criar um PSSR.',
          allowLeadsToShare:
            'Deseja permitir que os Líderes compartilhem o dispositivo com os aprovadores? Se selecionar "sim", o líder pode compartilhar o dispositivo com o aprovador se o aprovador estiver presente para assinar.',
          requireFinalApprovalBeforeInitiation:
            'Deseja exigir aprovação final antes da iniciação? Se "sim", o PSSR precisará ter um aprovador final para iniciá-lo.',
          allowFinalApproverNotifications: 'Deseja permitir que o aprovador final receba todas as notificações?',
          allowFinalApproverSubmit: 'Deseja permitir que o aprovador final envie para aprovação?',
          allowMultiplesApprovers: 'Deseja permitir múltiplos aprovadores?',
          ShowSectionsCollapsed: 'Deseja recolher as seções PSSR ao editar?',
          requireActionItemDueDate: 'Deseja exigir uma data de vencimento para itens de ação?',
          limitAccessToAIOwner:
            'Deseja restringir o proprietário ou atribuído do item de ação de modificar a descrição, alterar a data de vencimento ou excluir o item de ação?',
        },
        actionItemConfigurations: {
          titleItemConfigurations: 'Configurações de Itens de Ação',
          sendToMoc: 'Deseja enviar itens de ação para MOC?',
          p3: 'P3',
          p4: 'P4',
          allowTeamLeadAttach:
            'Deseja permitir que o líder da equipe anexe e modifique um item de ação? Se selecionar "sim", os líderes só podem anexar arquivos, atribuído, status e comentário após aprovação pendente.',
          allowActionItemOwnerAttach:
            'Deseja permitir que o proprietário do item de ação anexe em qualquer status enquanto o PSSR não estiver fechado?',
        },
      },
    },
  },
  user: {
    requestAccess: {
      title: 'Não registrado',
      forms: {
        submit: 'Solicitar acesso',
      },
      dialogTitle: 'Solicitar acesso',
      dialogSubtitle: 'Você está prestes a solicitar acesso para <strong>{{Name}}</strong>',
      reloadWarning:
        'Se você visitar esta página mas já tiver acesso, clique no link a seguir para recarregar; caso contrário, entre em contato com o suporte.',
      reload: 'Recarregar',
    },
    pendingAccess: {
      title: 'Olá, sua solicitação de acesso está em andamento',
      reloadWarning:
        'Se você visitar esta página mas já tiver acesso, clique no link a seguir para recarregar; caso contrário, entre em contato com o suporte.',
      reload: 'Recarregar',
    },
  },
  footer: {
    text: 'Chevron Corporation. Todos os direitos reservados.',
  },
  checklist: {
    title: 'Lista de Verificação PSSR',
    create: 'criar novo',
    hideCode: 'ocultar código',
    code: 'Código',
    name: 'Nome da lista de verificação',
    emptyHierarchyChildrenMessage:
      '<p>Não há <strong>{{childLabel}}</strong> disponível(is) para este(a) <strong>{{parentLabel}}</strong>.</p><p>Adicione um(a) novo(a) <strong>{{childLabel}}</strong> para começar.</p>',
    edit: 'editar',
    manage: 'gerenciar',
    delete: 'excluir',
    defaultWalkthroughDisclaimer: 'Isenção de responsabilidade de assinatura de passo a passo padrão',
    defaultSummaryDisclaimer: 'Isenção de responsabilidade de assinatura de resumo padrão',
    displayRichEditor: 'exibir editor de texto rico',
    sampleText: 'texto de exemplo',
    dialogs: {
      removeAccessHeader: 'Confirmação',
      removeAccessMessage: 'Tem certeza de que deseja excluir [{{description}}]?',
    },
    confirmDelete:
      '<span>¿Tem certeza de que deseja excluir esta lista de verificação?</span><br><br><span>Nome: {{ name }}<br>Descrição: {{ description }}</span>',
    noChecklists: 'Nenhuma checklist disponível.',
    titleCreate: 'Criar lista de verificação',
    createNew: 'Criar novo',
    selectPlaceholder: 'Selecione uma opção...',
    titleEdit: 'Lista de verificação de edição',
    titleDelete: 'Excluir lista de verificação',
    deletedSuccessfully: 'Lista de verificação excluída com sucesso',
    importChecklist: 'Importar lista de verificação',
    importChecklistTitle: 'Importar lista de verificação para ',
    selectChecklistType: 'Selecionar tipo de lista de verificação',
    confirm: 'Confirmar',
    importSuccessMessage: 'Lista de verificação importada com sucesso',
  },
  common: {
    yes: 'Sim',
    no: 'Não',
    na: 'N/D',
    save: 'Salvar',
    saving: 'Salvando...',
    businessUnit: 'Unidade de Negócio',
    forbidActionErrorMessage: 'O usuário não está autorizado a realizar esta ação',
    name: 'Nome',
    code: 'Código',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    back: 'Voltar',
    genericErrorMessage: 'Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.',
    errorOccurred: 'Ocorreu um erro. Tente novamente.',
    savedSuccessfully: 'Salvo com sucesso',
    delete: 'Excluir',
    deletedSuccessfully: 'Excluído com sucesso',
    edit: 'Editar',
    leaveWithOutSaving: 'Sair sem salvar',
    language: 'Idioma',
    month: 'Mês',
    months: 'Meses',
    loading: 'Carregando...',
    all: 'Todos',
    recordAlreadyExists: 'O registro já existe',
    recordCreatedSuccessfully: 'Registro criado com sucesso',
    createdSuccessfully: 'Criado com sucesso',
  },
  checklistManage: {
    title: 'Gerenciar conteúdo de [{{ description }}]',
    sectionsTitle: 'Sessões',
    addSectionAction: 'adicionar seção',
    mandatoryLabel: 'Obrigatório',
    createNewSubsectionAction: 'Criar novo Sub Sessão',
    emptySubSectionsMessage: `<p>Não há conteúdo disponível para esta seção.</p>
      <p>Por favor, adicione uma subseção para começar.</p>`,
    itemCodeTableHeader: 'Código',
    itemDescriptionTableHeader: 'Descrição',
    createNewItemAction: 'Adicionar pergunta',
    createSectionHeader: 'Criar Seção',
    editSectionHeader: 'Editar Seção',
    confirmDeleteSection: 'Tem certeza de que deseja excluir a seção <strong>{{description}}</strong>?',
    createSubSectionHeader: 'Criar subseção',
    editSubSectionHeader: 'Editar subseção',
    createChecklistItemTitle: 'Criar Item da Lista de Verificação',
    editChecklistItemTitle: 'Editar Item da Lista de Verificação',
    ShouldAddCommentToQuestion: 'O usuário deve adicionar um comentário a qualquer pergunta respondida com N/A',
    autoGenerateCodeLabel: 'Gerar código automaticamente',
    autoGenerateCodeplaceholder: 'O código será gerado automaticamente',
    autoGenerateCodeInfo: 'A geração automática foi ativada; o campo será preenchido automaticamente.',
    deleteChecklistItemTitle: 'Excluir Item da Lista de Verificação',
    confirmDeleteChecklistItem:
      '<span>Tem certeza de que deseja excluir este item da lista de verificação?</span><br><br><span><b>Código:</b> {{ name }}<br><b>Descrição:</b> {{ description }}</span>',
    confirmDeleteSubSection: 'Tem certeza de que deseja excluir a subseção <strong>{{description}}</strong>?',
    deleteSectionHeader: 'Excluir seção',
    deleteSubSectionHeader: 'Excluir subseção',
    editQuestionTitle: 'Editar Pergunta',
    sectionTypeLabel: 'Tipo de Seção',
    sectionTypePlaceholder: 'Selecione um tipo de seção',
    subSectionNameLabel: 'Nome da Subseção',
    itemTypeLabel: 'Tipo',
    itemTypePlaceholder: 'selecione um',
    codePlaceholder: 'Digite o código',
    duplicateCodeError: 'Este código já está sendo usado em outra seção.',
    displayRichEditorLabel: 'Exibir editor rico',
    requireCommentForNA: 'Você deseja exigir um comentário para uma pergunta N/A?',
  },
  paginator: {
    previous: 'Anterior',
    next: 'Próximo',
    currentPageReport: '{{currentInitialRow}} - {{currentLastRow}} de {{totalRecords}}',
  },
  usersList: {
    title: 'Usuários',
    forms: {
      displayInactiveUsers: 'exibir usuários inativos',
      search: 'Procurar',
    },
    actions: {
      addNewUser: 'Adicionar novo usuário',
      grantAccess: 'conceder acesso',
      reimportAllSharedUsers: 'Reimportar todos os usuários compartilhados',
    },
    table: {
      fullName: 'nome completo',
      email: 'e-mail',
      admin: 'admin',
      type: 'tipo',
    },
    noUsers: 'Nenhum usuário disponível',

    dialogs: {
      removeAccessHeader: 'Confirmação',
      removeAccessMessage: 'Tem certeza de que deseja remover o acesso para: [{{fullName}}]?',
      addUserHeader: 'Adicionar novo usuário',
      editUserHeader: 'Editar usuário',
      reimportSharedUsersHeader: 'Reimportar todos os usuários compartilhados',
      reimportSharedUsersMessage:
        'Você está prestes a atualizar a configuração de todos os usuários compartilhados.<br> Esta operação pode levar vários minutos para ser concluída.',
    },
    messages: {
      importSharedUsersFailed: 'Falha na importação',
      importSharedUsersIncompleted: 'Importação incompleta',
      importSharedUsersCompleted: 'Importação concluída em: {{ minutes }} mins',
      pleaseWaitUntilProcessEnds:
        'Aguarde até que o processo de importação seja concluído. Não feche nem saia desta página.',
      importInProgress: 'A importação está em andamento. Aguarde a conclusão antes de fechar a página.',
      calculatingProgress: 'Calculando progresso...',
    },
    labels: {
      imported: 'Importado',
      notFound: 'Não encontrado',
      errors: 'Erros',
      total: 'Total',
    },
  },
  actionItems: {
    title: 'Itens de Ação',
    addActionItem: 'adicionar item de ação',
    noActionItems: 'Nenhum item de ação disponível',
    canOnlyPerformAttachments:
      'Você só pode gerenciar anexos de arquivo. Outras propriedades do item de ação não podem ser editadas.',
    actionTitle: 'Título',
    assignee: 'Responsável',
    date: 'Data',
    dueDate: 'Data de vencimento',
    category: 'Categoria',
    primaryCategory: 'Categoria primária',
    secondaryCategory: 'Categoria secundária',
    subcategory: 'Subcategoria',
    id: 'ID',
    comment: 'Comentário',
    editComment: 'Editar Comentário',
    commentRequiredWhenClosed: 'Comentário é obrigatório quando o status está definido como Fechado',
    priority: 'Prioridade',
    assignTo: 'Atribuir a',
    pssrCccMembers: 'Membros {{pssrTitle}}',
    chevronDirectory: 'Diretório Chevron',
    userGroup: 'Grupo de usuários',
    other: 'Outro',
    status: 'Status',
    statusNames: {
      Open: 'Aberto',
      Closed: 'Fechado',
      Cancel: 'Cancelado',
      Rejected: 'Rejeitado',
    },
    createdBy: 'Criado por',
    updatedDate: 'Data de atualização',
    updatedBy: 'Atualizado por',
    selectOne: 'Selecione um...',
    typeNameOrEmail: 'Digite nome ou e-mail...',
    inactive: 'Inativo',
    reopen: 'Reabrir',
    reject: 'Rejeitar',
    rejectReason: 'Razão da Rejeição',
    rejectReasonPlaceholder: 'Digite o motivo da rejeição',
    timeCaptured: 'Hora Capturada',
    attachments: 'Anexos',
    pssrFiles: 'Arquivos PSSR',
    links: 'Links',
    fileUpload: 'Upload de arquivo',
    attachFiles: 'Anexar (docs, imagens, etc.)',
    fileTooLarge: 'O arquivo \'{{name}}\' excede o tamanho máximo permitido de {{max}}.',
    invalidFileFormat: 'O arquivo \'{{name}}\' tem um formato não suportado.',
    duplicateFile: 'O arquivo \'{{name}}\' já foi adicionado.',
    linkPlaceholder: 'www.exemplo.com',
    dialogs: {
      configureActionItem: 'Configurar Item de Ação',
      configureComment: 'Comentário',
      deleteActionItemHeader: 'Excluir item de ação',
      deleteActionItemMessage: 'Tem certeza de que deseja realizar esta ação?',
      rejectActionItemHeader: 'Rejeitar Item de Ação',
      confirmPriorityChangeHeader: 'Confirmar Mudança de Prioridade',
      confirmPriorityChangeMessage: 'Tem certeza de que deseja alterar a prioridade deste item de ação?',
      deleteAttachmentHeader: 'Excluir Anexo',
      deleteAttachmentMessage: 'Tem certeza de que deseja excluir este anexo?',
    },
    messages: {
      deleteSuccess: 'Item de ação excluído com sucesso',
      reopenSuccess: 'Item de ação reaberto com sucesso',
      rejectSuccess: 'Item de ação rejeitado com sucesso',
      rejectReasonRequired: 'O motivo da rejeição é obrigatório',
      confirmReject: 'Tem certeza de que deseja rejeitar este item de ação? Ele será {{action}}.',
      confirmRejectP4: 'Tem certeza de que deseja rejeitar este item de ação?',
      returnToTeamLead: 'devolvido ao Líder da Equipe',
      confirmReopen: 'Tem certeza de que deseja reabrir este item de ação?',
    },
  },
  actionItemsList: {
    title: 'Itens de Ação',
    sections: {
      location: 'Localização',
      pssr: 'PSSR',
      actionItem: 'Item de Ação',
    },
    fields: {
      area: 'Área',
      facilityOperationTeam: 'Equipe de Operações da Instalação',
      facility: 'Instalação',
      titleStatus: 'Status do Título',
      type: 'Tipo',
      title: 'Título',
      project: 'Projeto',
      template: 'Modelo',
      leadFinalApprover: 'Líder/Aprovador Final',
      showOnlyDeletedPssr: 'Mostrar Apenas PSSR Excluídos',
      status: 'Status',
      priority: 'Prioridade',
      assignedTo: 'Atribuído a',
      autoLoadImages: 'Carregamento Automático de Imagens',
    },
    placeholders: {
      selectOne: 'selecione um',
      sampleText: 'texto de exemplo',
      no: 'Selecione Não',
    },
    priorityDescriptions: {
      p3: 'O item deve ser concluído antes da inicialização',
      p4: 'O item será concluído após a inicialização',
      p5: 'O item deve ser concluído antes da inicialização',
    },
    priorityLegend: {
      title: 'Prioridades dos Itens de Ação',
    },
    actions: {
      clearFilter: 'limpar filtro',
      exportExcel: 'exportar excel',
      noDataToExport: 'Sem itens de ação para exportar',
    },
    imageAltText: 'Imagem do Item de Ação',
    pssrTeamLead: 'Líder da Equipe PSSR',
    finalApprover: 'Aprovador Final',
    subsection: 'Subseção',
    code: 'Código',
    question: 'Pergunta',
    answer: 'Resposta',
    noData: 'Nenhum item de ação disponível',
    noDataFound: 'Nenhum item de ação encontrado para os filtros selecionados',
  },
  responseSignature: {
    signedBy: 'Assinado Por',
    signedOn: 'Assinado Em',
    name: 'Nome',
    dateCaptured: 'Data Capturada',
    sign: 'Assinar',
    finalApproverLabel: 'Aprovador Final',
    dialogs: {
      deleteHeader: 'Excluir assinatura',
      deleteMessage: 'Você está prestes a excluir a assinatura, por favor selecione confirmar para continuar',
      cancel: 'cancelar',
      delete: 'excluir',
    },
  },
  comments: {
    title: 'Comentários',
    addComment: 'adicionar comentário',
    dialogs: {
      configureComment: 'Comentário',
      deleteCommentHeader: 'Excluir Comentário',
      deleteCommentMessage: 'Tem certeza de que deseja realizar esta ação?',
    },
    comment: 'Comentário',
  },
  userType: {
    Chevron: 'Chevron',
    External: 'Contratado',
    Shared: 'Compartilhado',
  },
  areas: {
    title: 'Área',
    showDeletedItems: 'Mostrar itens excluídos',
    areaListTitle: 'Lista de áreas',
    createFacilityOperationTeam: 'Criar nova equipe de operação da instalação',
    createFacility: 'Criar nova instalação',
    restore: 'Restaurar',
    emptySubAreaMessage:
      '<p>Não há conteúdo disponível para esta área.</p><p>Por favor, adicione uma nova equipe de operação da instalação para começar.</p>',
    emptyHierarchyChildrenMessage:
      '<p>Não há <strong>{{childLabel}}</strong> disponível(is) para este(a) <strong>{{parentLabel}}</strong>.</p><p>Adicione um(a) novo(a) <strong>{{childLabel}}</strong> para começar.</p>',
    emptyAreaMessage:
      '<p>Não há conteúdo disponível para esta unidade de negócio.</p><p>Por favor, adicione uma nova área para começar.</p>',
    subareaTitle: 'Equipe de Operação da Instalação',
    facilityTitle: 'Instalação',
    removeConfirmationHeader: 'Confirmação',
    confirmDeleteArea: 'Tem certeza de que deseja excluir a Área <strong>{{description}}</strong>?',
    confirmDeleteSubarea:
      'Tem certeza de que deseja excluir a Equipe de Operação da Instalação <strong>{{description}}</strong>?',
    confirmDeleteFacility: 'Tem certeza de que deseja excluir a Instalação <strong>{{description}}</strong>?',
    restoredSuccessfully: 'Restaurado com sucesso',
  },
  pssrImport: {
    title: 'Importar MOC',
    sections: {
      import: 'Importar',
    },
    forms: {
      labels: {
        application: 'Aplicação',
        pssrId: 'ID',
        mocId: 'ID do MOC',
        mocName: 'Nome do MOC',
      },
      placeholders: {
        application: 'selecione uma opção',
        pssrId: 'Digite o ID do MOC',
        mocName: 'Preenchido automaticamente do iMOC',
      },
      validation: {
        mocIdRequired: 'O ID do MOC é obrigatório',
        applicationRequired: 'Aplicação é obrigatória',
      },
    },
    actions: {
      add: 'Adicionar',
      addMoc: 'Adicionar MOC',
      importAll: 'Importar Tudo',
      createPssr: 'criar PSSR',
      searchMoc: 'buscar MOC',
      importMocCreatePssr: 'Importar MOC e criar PSSR',
    },
    table: {
      id: 'ID',
      pssrId: 'ID PSSR',
      name: 'Nome',
      status: 'Status',
    },
    summary: {
      records: 'Registros',
      imported: 'Importados',
      errors: 'Erros',
    },
    status: {
      pending: 'Pendente',
      inProgress: 'Em Andamento',
      imported: 'Importado',
      warning: 'Aviso',
      error: 'Erro',
    },
    messages: {
      alreadyInList: 'O ID do PSSR já está na lista de importação.',
      pssrNotFound: 'PSSR não encontrado.',
    },
  },
  pssrCreate: {
    title: 'Criar PSSR',
    sections: {
      generalInformation: 'Informações Gerais',
      location: 'Localização',
      details: 'Detalhes',
      instructions: 'Instruções',
    },
    forms: {
      labels: {
        title: 'Título',
        moc: 'MOC',
        wo: 'WO',
        description: 'Descrição',
        area: 'Área',
        facilityOperationTeam: 'Equipe de Operação da Instalação',
        facility: 'Instalação',
        project: 'Projeto',
        template: 'Modelo',
        type: 'Tipo',
        organization: 'Organização',
        subArea: 'Subárea',
        includeProjectTeam: 'Incluir membros da equipe do projeto',
      },
      placeholders: {
        title: 'texto de exemplo',
        moc: 'texto de exemplo',
        wo: 'texto de exemplo',
        description: 'Digite a descrição',
        area: 'selecione um',
        facilityOperationTeam: 'selecione um',
        facility: 'selecione um',
        project: 'selecione um',
        template: 'selecione um',
        type: 'selecione um',
        subArea: 'selecione um',
      },
      validation: {
        titleRequired: 'O título é obrigatório',
        mocRequired: 'MOC é obrigatório',
        woRequired: 'WO é obrigatório',
        businessUnitRequired: 'A unidade de negócio é obrigatória',
        organizationRequired: 'A organização é obrigatória',
        areaRequired: 'A área é obrigatória',
        facilityOperationTeamRequired: 'A equipe de operação da instalação é obrigatória',
        facilityRequired: 'A instalação é obrigatória',
        projectRequired: 'O projeto é obrigatório',
        templateRequired: 'O modelo é obrigatório',
        typeRequired: 'O tipo é obrigatório',
        requiredFieldsMessage: 'Nota: Preencha os campos marcados como obrigatórios. Clique em Salvar.',
      },
      templateChangeConfirmTitle: 'Alterar modelo',
      templateChangeConfirmMessage:
        'Alterar o modelo atualizará as seções do PSSR. Tem certeza de que deseja alterar o modelo?',
    },
    actions: {
      create: 'criar',
      pullFromKMS: 'Puxar do KMS',
    },
    successMessage: 'PSSR criado com sucesso',
  },
  pssrKms: {
    title: 'PSSR do KMS',
    sections: {
      generalInformation: 'Informações Gerais',
      pssrInformation: 'Informações PSSR',
      location: 'Localização',
      details: 'Detalhes',
    },
    kmsInstruction:
      'Pesquise um número MOC específico ou filtre a lista por status e tamanho de página para importar dados do KMS.',
    searchMOCNumber: 'Pesquisar Número MOC',
    mocPattern: 'ex., MOC-2024-123',
    invalidMOCFormat: 'Formato MOC inválido. Exemplo: MOC-2024-123',
    search: 'Pesquisar',
    filterByStatus: 'Filtrar Lista KMS por Status',
    filterPageSize: 'Filtrar Número de Itens KMS retornados',
    selectFromList: 'Selecionar da Lista MOC KMS',
    selectKMSItems: 'Selecionar itens KMS',
    createNew: 'Criar Novo',
    enterName: 'Digite o nome',
    add: 'Adicionar',
    enterProjectNumber: 'Digite o número do projeto',
    selectQAQCEvent: 'Selecionar evento QAQC',
    selectFromQAQC: 'Selecionar do QAQC',
    milestones: 'Marcos',
    workOrders: 'Ordens de Serviço',
    selectMilestone: 'Selecionar marco',
    selectWorkOrder: 'Selecionar ordem de serviço',
    milestoneWorkOrders: 'Ordens de Serviço de Marcos',
    note: 'Nota',
    fillRequiredFields: 'Por favor, preencha os campos marcados como obrigatórios',
    generatePSSRs: 'Gerar PSSRs',
    successMessage: 'PSSR do KMS criado com sucesso',
    multipleSuccessMessage: 'Múltiplos PSSRs do KMS criados com sucesso',
    loadingKMSItemsError: 'Erro ao carregar itens KMS. Por favor, tente novamente.',
    selectKMSItemsWarning: 'Por favor, selecione pelo menos um item KMS',
    kmsStatus: {
      draft: 'Rascunho',
      processActivated: 'Processo Ativado',
      reviewInProgress: 'Revisão em Andamento',
      implementationInProgressEdit: 'Implementação em Andamento Editar',
      changeRequestApproved: 'Solicitação de Mudança Aprovada',
      changeRequestDenied: 'Solicitação de Mudança Negada',
      implementationInProgress: 'Implementação em Andamento',
      readyToStartUp: 'Pronto para Iniciar',
      completed: 'Concluído',
      canceled: 'Cancelado',
      onHold: 'Em Espera',
    },
    businessUnit: 'Unidade de Negócio',
    selectPlaceholder: 'Selecione um',
  },
  pssrSubSections: {
    actions: {
      addQuestion: 'Adicionar pergunta',
    },
  },
  pssrDetails: {
    title: 'Detalhes do PSSR',
    pssrId: 'ID do PSSR',
    sections: {
      generalInformation: 'Informações Gerais',
      location: 'Localização',
      details: 'Detalhes',
      sectionsTitle: 'Seções',
      actionItems: 'Itens de Ação',
      comments: 'Comentários',
      enableCustomOrderForSections: 'Ativar ordem personalizada para seções',
      sectionsLegendTitle: 'Legenda de seções',
      hideCompletedQuestions: 'Ocultar perguntas concluídas',
      saveSectionOrder: 'Salvar ordem das seções',
      confirmRemoveSectionTitle: 'Remover seção',
      confirmRemoveSectionDescription: 'Tem certeza de que deseja remover {{description}}?',
      sectionNameLabel: 'Nome da Seção',
      sectionNamePlaceholder: 'Digite o nome da seção',
      editSectionName: 'Editar nome da seção',
      addMultipleSectionName: 'Adicionar seção múltipla',
      validation: {
        sectionNameRequired: 'O nome da seção é obrigatório',
        sectionNameDuplicated: 'Já existe uma seção com este nome',
      },
      toast: {
        unableToCompleteOperation: 'Não foi possível concluir a operação',
        saveCompletedTitle: 'Salvamento concluído',
        sectionsSortedSuccessfully: 'As seções foram ordenadas com sucesso',
        loadSectionsError: 'Erro ao carregar as seções. Por favor, tente novamente.',
        userAlreadyAdded: 'Usuário já adicionado a esta seção',
        userAddedSuccessfully: 'Usuário adicionado com sucesso',
        sectionAddedSuccessfully: 'Seção adicionada com sucesso',
        sectionUpdatedSuccessfully: 'Seção atualizada com sucesso',
      },
      selectLead: 'Selecionar líder',
      section1Title: 'Seção 1',
      legend: {
        defaultQuestionLabel: 'pergunta padrão',
        defaultQuestionDescription: 'pergunta que pode ser respondida com sim, não ou n/a',
        optionalLabel: 'opcional',
        optionalDescription: 'pode ser adicionada manualmente ao PSSR',
        multipleLabel: 'múltipla',
        multipleDescription: 'opcional, mas pode ser adicionada várias vezes ao PSSR',
        mandatoryLabel: 'obrigatório',
      },
      instructions: 'Instruções',
      history: 'Histórico de alterações PSSR',
      attachments: 'Anexos PSSR',
    },
    subsections: {
      actionItemNeeded: 'Nota: Item de ação necessário para completar as perguntas.',
    },
    questions: {
      code: 'Código',
      question: 'Pergunta',
      answer: 'Resposta',
      updatedBy: 'Atualizado Por',
      updatedDate: 'Data de Atualização',
      clearAnswer: 'limpar resposta',
      deleteQuestion: 'excluir pergunta',
      answerUpdated: 'Resposta atualizada com sucesso',
      answerCleared: 'Resposta limpa com sucesso',
      questionDeleted: 'Pergunta excluída com sucesso',
      confirmDeleteTitle: 'Excluir Pergunta',
      confirmDeleteMessage: 'Tem certeza de que deseja excluir esta pergunta: {{question}}?',
      validation: {
        actionItemIsNeeded: 'É necessário um item de ação para completar a pergunta',
        commentIsNeeded: 'É necessário um comentário para completar a pergunta',
        signatureIsNeeded: 'É necessária uma assinatura para completar a pergunta',
        responseIsNeeded: 'É necessária uma resposta para completar a pergunta',
        actionItemsClosedOrCancelledNeeded:
          'Itens de ação {{P3Label}} fechados ou cancelados são necessários para completar a pergunta',
      },
    },
    forms: {
      labels: {
        title: 'Título',
        moc: 'MOC',
        wo: 'WO',
        description: 'Descrição',
        area: 'Área',
        facilityOperationTeam: 'Equipe de Operação da Instalação',
        facility: 'Instalação',
        project: 'Projeto',
        template: 'Modelo',
        type: 'Tipo',
      },
      placeholders: {
        title: 'texto de exemplo',
        moc: 'texto de exemplo',
        wo: 'texto de exemplo',
        description: 'Digite a descrição',
        area: 'selecione um',
        facilityOperationTeam: 'selecione um',
        facility: 'selecione um',
        project: 'selecione um',
        template: 'selecione um',
        type: 'selecione um',
      },
      validation: {
        titleRequired: 'O título é obrigatório',
        businessUnitRequired: 'A unidade de negócio é obrigatória',
        organizationRequired: 'A organização é obrigatória',
        areaRequired: 'A área é obrigatória',
        facilityOperationTeamRequired: 'A equipe de operação da instalação é obrigatória',
        facilityRequired: 'A instalação é obrigatória',
        templateRequired: 'O modelo é obrigatório',
        typeRequired: 'O tipo é obrigatório',
        requiredFieldsMessage: 'Nota: Preencha os campos marcados como obrigatórios. Clique em Salvar.',
      },
      templateChangeConfirmTitle: 'Alterar modelo',
      templateChangeConfirmMessage:
        'Alterar o modelo atualizará as seções do PSSR. Tem certeza de que deseja alterar o modelo?',
    },
    actions: {
      save: 'salvar',
      saveGeneralInformation: 'salvar informações gerais',
      showFullHistory: 'mostrar histórico completo',
      showLessHistory: 'mostrar menos histórico',
      attachFile: 'Anexar arquivo (documentos, imagens, desenhos psi, etc.)',
      attachFileButton: 'anexar arquivo',
      printToPdf: 'imprimir em pdf',
      sendEmailReminder: 'enviar lembrete por e-mail',
      importMocActionItems: 'importar itens de ação moc',
      sendToMocStartup: 'enviar para registro moc para aprovação de inicialização',
      returnToTeamLead: 'retornar ao líder da equipe',
      start: 'iniciar pssr',
      reject: 'rejeitar',
      delete: 'excluir',
      restorePssr: 'restaurar pssr',
      reopen: 'reabrir',
    },
    mocImportedHint: 'Esta PSSR foi importada. Você não pode alterar o id dela',
    history: {
      reason: 'Motivo',
      by: 'Por',
      draftCreated: 'Rascunho Criado Em',
      initiated: 'Iniciado Em',
      started: 'Começado Em',
      completed: 'Concluído Em',
      pendingApproval: 'Aprovação Pendente Em',
      verbalApproval: 'Aprovação Verbal Em',
      approved: 'Aprovado Em',
      rejected: 'Rejeitado Em',
      restored: 'Restaurado Em',
      deleted: 'Excluído Em',
      closed: 'Fechado Em',
    },
    successMessage: 'PSSR atualizado com sucesso',
    pdfDownloadSuccess: 'PDF baixado com sucesso',
    pssrDeletedSuccess: 'PSSR excluído com sucesso',
    pssrReopenedSuccess: 'PSSR reaberto com sucesso',
    statusChangedSuccess: 'Status do PSSR alterado com sucesso',
    pssrRejectedSuccess: 'PSSR rejeitado com sucesso',
    pssrRestoredSuccess: 'PSSR restaurado com sucesso',
    importMOCActionsSuccess: 'Itens de ação MOC importados com sucesso',
    sendToMOCSuccess: 'Carregado para MOC com sucesso',
    emailSentSuccess: 'Lembrete por e-mail enviado com sucesso',
    importMOCActionsNone: 'Nenhum item de ação MOC para importar',
    lastSent: 'Último Envio',
    messages: {
      questionAdded: 'Pergunta adicionada com sucesso',
    },
    dialogs: {
      addQuestion: {
        descriptionLabel: 'Descrição',
        descriptionPlaceholder: 'Digite a descrição da pergunta',
        descriptionRequired: 'A descrição é obrigatória',
      },
    },
    rejectDialog: {
      title: 'Rejeitar PSSR',
      reasonLabel: 'Motivo da Rejeição',
      cancel: 'Cancelar',
      confirm: 'Rejeitar',
    },
    emailReminderDialog: {
      title: 'Enviar Lembrete por E-mail',
      sendReminder: 'Enviar Lembrete',
      sendMessage: 'Enviar Mensagem Personalizada',
      reminderInstructions:
        'Enviar lembrete aos designados para todos os AIs abertos. Quando o PSSR estiver no status Aprovação Pendente, os Aprovadores receberão notificação.',
      messageInstructions: 'Enviar uma mensagem de e-mail para todos os Participantes do PSSR',
      enterText: 'Digite sua mensagem...',
      cancel: 'Cancelar',
      confirm: 'Enviar',
    },
    commentDialog: {
      title: 'Comentário',
      commentLabel: 'Comentário',
      commentPlaceholder: 'texto de exemplo',
      createdBy: 'Criado por',
      updatedDate: 'Data de atualização',
      updatedBy: 'Atualizado por',
      documents: 'Documentos',
      delete: 'excluir',
      cancel: 'cancelar',
      save: 'salvar',
      successMessage: 'Comentário atualizado com sucesso',
      confirmDeleteAttachment: 'Tem certeza de que deseja excluir este anexo?',
      confirmDeleteAttachmentHeader: 'Excluir Anexo',
      commentRequired: 'O comentário é obrigatório',
      addComment: 'Adicionar Comentário',
      editComment: 'Editar Comentário',
      confirmDelete: 'Tem certeza de que deseja excluir este comentário?',
      confirmDeleteHeader: 'Excluir Comentário',
      commentAdded: 'Comentário adicionado com sucesso',
      commentUpdated: 'Comentário atualizado com sucesso',
      commentDeleted: 'Comentário excluído com sucesso',
    },
    confirmDeleteHeader: 'Confirmar Exclusão',
    confirmDeleteMessage: 'Você está prestes a excluir este item. Deseja continuar?',
    confirmDeleteComment: 'Tem certeza de que deseja excluir este comentário?',
    commentDeletedSuccess: 'Comentário excluído com sucesso',
    changeStatusHeader: 'Confirmar Mudança de Status',
    confirmChangeStatus: 'Você deseja mudar o status?',
    confirmReturnToTeamLead: 'Deseja devolver este PSSR ao Líder da Equipe?',
    confirmRejectHeader: 'Confirmar Rejeição',
    confirmRejectMessage: 'Tem certeza de que deseja rejeitar este PSSR?',
    confirmReopenHeader: ' ',
    confirmReopenMessage: 'Tem certeza de que deseja reabrir este PSSR?',
    comments: {
      title: 'Comentários',
      addComment: 'adicionar comentário',
      noComments: 'Nenhum comentário adicionado',
      by: 'por',
      on: 'em',
    },
    validation: {
      onlyPSSRTeamLeadcanInitiatePSSR: 'Somente o líder da equipe de PSSR pode iniciar a PSSR',
      requireFinalApproverBeforeInitiation: 'Se marcado, o PSSR exigirá um aprovador final para iniciá-lo',
      pssrMustAnswerAllQuestionsToCompleteWalkdown:
        'Responder todas as perguntas e assinaturas para concluir a inspeção',
      pssrMustHaveFinalApproverToCompleteWalkdown: 'A PSSR deve ter um aprovador final para concluir a inspeção',
      onlyPSSRTeamLeadcanSubmitforPendingApproval:
        'Somente o Líder da equipe de PSSR pode enviar para aprovação pendente',
      p3ActionItemsMustBeClosed: 'Os itens de ação P3 devem ser fechados',
      p4ActionItemsMustBeClosed: 'Os itens de ação P4 devem ser fechados',
      onlyFinalApprovercanApprovePSSR: 'Somente o aprovador final pode aprovar a PSSR',
      onlyPSSRTeamLeadClosePSSR: 'Somente o líder da equipe de PSSR pode encerrar a PSSR',
    },
  },
  pdfDialog: {
    header: 'Anexar arquivo PDF',
    selectTypePrompt: 'Como você gostaria de anexar este PDF?',
    document: 'Documento',
    image: 'Imagem',
    selectPagesTitle: 'Selecione as páginas para converter em imagens',
    allPages: 'Todas as páginas',
    selectPages: 'Selecionar páginas',
    page: 'Página',
    select: 'Selecionar',
    couldNotDetectPages: 'Não foi possível detectar o número de páginas. Todas as páginas serão incluídas.',
  },
  attachmentUpload: {
    title: 'Anexar Arquivo',
    selectType: 'O que você gostaria de anexar?',
    types: {
      link: 'Link',
      document: 'Documento',
      image: 'Imagem',
    },
    forms: {
      url: 'URL',
      urlPlaceholder: 'https://exemplo.com',
    },
    clickToSelect: 'Clique para selecionar um arquivo',
    acceptedImageTypes: 'Formatos aceitos: JPG, PNG, GIF, etc.',
    acceptedDocumentTypes: 'Formatos aceitos: PDF, DOC, DOCX, XLS, XLSX',
    upload: 'Enviar',
    successMessage: 'Arquivo anexado com sucesso',
    sections: {
      images: 'Imagens',
      documents: 'Documentos',
      links: 'Links',
    },
    uploaded: 'Carregado',
    download: 'Baixar',
  },
  organizationsList: {
    title: 'Organizações',
    tableHeader: 'organização',
    noOrganizations: 'Nenhuma organização disponível',
    successCreated: 'Organização criada com sucesso',
    actions: {
      addNew: 'adicionar nova organização',
    },
    forms: {
      name: 'Nome da organização',
      namePlaceholder: 'digite nome da organização',
    },
    dialogs: {
      addNew: 'Adicionar nova organização',
      edit: 'Editar organização',
      deleteHeader: 'Excluir organização',
      deleteMessage: 'Tem certeza de que deseja excluir a organização: [{{name}}]?',
    },
  },
  userGroupsList: {
    title: 'Grupos de usuários de itens de ação',
    groupsSection: 'Grupos',
    noUsers: 'Nenhum usuário neste grupo',
    noGroups: 'Nenhum grupo disponível',
    selectGroup: 'Selecione um grupo para visualizar usuários',
    actions: {
      create: 'criar',
      addNewUser: 'adicionar novo usuário',
      selectUser: 'Selecionar usuário',
      changeUser: 'Alterar usuário',
      add: 'Adicionar',
    },
    table: {
      userName: 'nome de usuário',
      email: 'e-mail',
    },
    forms: {
      namePlaceholder: 'Digite o nome do grupo',
      selectUserPrompt: 'Por favor, selecione um usuário para adicionar a este grupo',
      selectedUser: 'Usuário selecionado',
    },
    dialogs: {
      addGroup: 'Adicionar novo grupo',
      editGroup: 'Editar grupo',
      deleteGroupHeader: 'Excluir grupo',
      deleteGroupMessage: 'Tem certeza de que deseja excluir o grupo: [{{name}}]?',
      removeUserHeader: 'Remover usuário',
      removeUserMessage: 'Tem certeza de que deseja remover {{name}} deste grupo?',
      addUser: 'Adicionar usuário ao grupo',
      selectUser: 'Selecionar usuário',
    },
  },
  participants: {
    title: 'Participantes',
    addParticipant: 'adicionar participante',
    addMember: 'Adicionar membro',
    pssrTeamLead: 'Líder de Equipe {{pssrTitle}}',
    pssrTeam: 'Equipe {{pssrTitle}}',
    projectManagers: 'Gerentes de Projeto',
    projectTeamMembers: 'Membros da Equipe do Projeto',
    operationsRepresentative: 'Representante de Operações',
    finalApprover: 'Aprovador Final',
    actionItemAssignee: 'Responsável pelo Item de Ação',
    noParticipantsAdded: 'Nenhum participante adicionado',
    signedBy: 'assinado por',
    signedInBehalfOf: 'assinado em nome de',
    signedOn: 'assinado em',
  },
  qaqcImport: {
    title: 'Importação QAQC',
    milestone: 'Marco QAQC',
    workOrders: 'Ordens de Trabalho QAQC',
    milestoneWorkOrders: 'Ordens de Trabalho do Marco QAQC (opcional)',
    milestoneWorkOrdersLabel: 'Ordens de Trabalho do Marco QAQC',
    milestoneWorkOrdersMessage: 'Selecione 1 marco para ver as ordens de trabalho dentro desse marco',
    noItemsAvailable: 'Nenhum marco/ordem de trabalho disponível do QAQC',
    noWorkOrdersForMilestone: 'Não há ordens de trabalho disponíveis para este marco',
    unableLoadItems:
      'Não foi possível acessar o sistema QAQC para marcos/ordens de trabalho, tente novamente mais tarde',
    loadEventsError: 'Erro ao obter {{eventLabel}} do QAQC',
    multipleMilestonesWarning: 'Please select 1 milestone to view work orders within that milestone',
    generatePssrTitle: 'Gerar Título PSSR',
    alreadyExists: 'Este evento QAQC já existe como projeto',
    selectEvent: 'Projeto',
    sections: 'Seções',
    assignSectionLeads: 'Atribuir líderes de seção',
    selectLead: 'Selecionar Líder',
    sectionName: 'Nome da Seção',
    lead: 'Líder',
    template: 'Modelo',
    type: 'Tipo',
    projectType: 'Tipo de Projeto',
    successMessage: 'Importação QAQC concluída. Projeto e PSSRs criados.',
    errorMessage: 'Erro ao criar projeto QAQC. Tente novamente.',
    projectCreatedWithoutItems:
      'Projeto criado. O QAQC ainda não tem marcos nem ordens de trabalho; use "Carregar novos itens QAQC" quando estiverem disponíveis.',
    partialErrorMessage:
      'O projeto foi criado, mas seus PSSRs não puderam ser criados. Use "Carregar novos itens QAQC" para tentar novamente.',
    somePssrsNotCreated:
      'Apenas {{created}} de {{total}} PSSRs foram criados. Use "Carregar novos itens QAQC" para criar os demais.',
  },
  participantDialog: {
    title: 'Selecionar participante',
    addParticipant: 'Adicionar Participante',
    selectUserType: 'Selecionar Tipo de Usuário',
    selectedUserType: 'Tipo de Usuário Selecionado',
    chevronDirectory: 'diretório chevron/usuários compartilhados',
    newNonChevron: 'novo não chevron',
    searchPlaceholder: 'Buscar por email...',
    emailPlaceholder: 'Digite o email...',
    namePlaceholder: 'Digite o nome...',
    selectRole: 'Selecionar função',
    selectedRole: 'Função Selecionada',
    selectOne: 'selecione um',
    add: 'adicionar',
    stagedParticipants: 'a adicionar:',
    batchLimitReached: 'limite de {{limit}} utilizadores atingido, selecione adicionar',
    alreadyStagedError: 'este utilizador já está na lista',
    successMessage: 'Participante adicionado com sucesso',
    added: 'Participante adicionado com sucesso',
    addError: 'Erro ao adicionar participante',
    alreadyParticipantPssr: 'Este usuário já é participante deste PSSR como {{role}}',
    alreadyMemberProject: 'Este usuário já é membro deste projeto como {{role}}',
  },
  participantEditDialog: {
    title: 'Editar participante',
    user: 'Usuário',
    selectRole: 'Selecionar função',
    delete: 'excluir',
    captureSignature: 'capturar assinatura',
    recaptureSignature: 'recapturar assinatura',
    removeSignature: 'remover assinatura',
    removeSignatureSuccess: 'Assinatura removida com sucesso',
    save: 'salvar',
    noSignature: 'Nenhuma assinatura capturada',
    successMessage: 'Participante atualizado com sucesso',
    deleteSuccessMessage: 'Participante removido com sucesso',
    deleteConfirmHeader: 'Excluir Participante',
    deleteConfirmMessage: 'Tem certeza de que deseja remover este participante?',
  },
  buAdminsList: {
    title: 'Usuários Administradores de BU',
    actions: {
      addNewUser: 'adicionar usuário administrador',
      delete: 'excluir',
    },
    table: {
      fullName: 'nome completo',
      email: 'e-mail',
    },
    noAdmins: 'Nenhum usuário administrador disponível',
  },
  externalUserForm: {
    labels: {
      firstName: 'Primeiro Nome',
      lastName: 'Sobrenome',
      email: 'Email',
      userNameEmail: 'Email o nome de usuário',
    },
  },
  sharedUserForm: {
    labels: {
      sharedUserGroup: 'Grupo de usuários compartilhados',
      sharedEmail: 'Email compartilhado',
    },
    actions: {
      addChildUser: 'adicionar usuário',
      importSharedUsers: 'Importar usuários compartilhados',
    },
    whitePages: {
      title: 'Integração com White Pages',
      description:
        'Use este tipo de email compartilhado se precisar sincronizar com White Pages. A lista de usuários será atualizada automaticamente ao longo do tempo. Alguns usuários podem ser automaticamente adicionados ou removidos deste email compartilhado.',
    },
    customConfiguration: {
      title: 'Configuração personalizada',
      description: 'Gerencie manualmente a lista de usuários.',
    },
  },
  pssrsList: {
    title: 'PSSR',
    location: 'Localização',
    details: 'Detalhes',
    emptyMessage: 'Nenhum PSSR encontrado',
    searchByLocation: 'Localização',
    searchByDetails: 'Detalhes',
    filters: {
      businessUnit: 'Unidade de Neg\u00f3cios',
      organization: 'Organiza\u00e7\u00e3o',
      area: '\u00c1rea',
      subArea: 'Sub \u00c1rea',
      facilityOperationTeam: 'Equipe de Operação de Instalação',
      facility: 'Facilidade',
      project: 'Projeto',
      template: 'Modelo',
      selectOne: 'selecione um',
      status: 'Status',
      type: 'Tipo',
      deletedStagnant: 'Exclu\u00eddo/Estagnado',
      showOnlyDeleted: 'mostrar apenas pssrs excluídos',
      showOnlyStagnant: 'mostrar apenas pssrs estagnados',
      search: 'Pesquisar',
      placeholderSearch: 'pesquisar por moc, wo, id pssr, t\u00edtulo, etc...',
      userSearch: 'Pesquisa de Usu\u00e1rio',
      placeholderUserSearch: 'sample text',
      isStagnant: '\u00c9 Estagnado',
      isDeleted: '\u00c9 Exclu\u00eddo',
    },
    buttons: {
      clearFilter: 'limpar filtro',
      newPssr: 'novo PSSR',
      viewItems: 'ver itens',
      open: 'abrir',
    },
    actions: {
      clearFilter: 'Limpar filtro',
      newPssr: 'Nova PSSR',
      importPssr: 'Importar PSSRs',
    },
    table: {
      id: 'ID',
      sectionNameLabel: 'Nome da Seção',
      commentDialog: {
        confirmDelete: '',
        confirmDeleteHeader: '',
      },
      title: 'Título',
      type: 'Tipo',
      status: 'Status',
      facility: 'Facilidade',
      project: 'Projeto',
    },
    statusOptions: {
      draft: 'Rascunho',
      initiated: 'Iniciado',
      inProgress: 'Em andamento',
      completed: 'Concluído',
      pendingApproval: 'Aprovação pendente',
      approved: 'Aprovado',
      closed: 'Fechado',
    },
    noPssrs: 'Nenhum PSSR disponível',
  },
  pssrListItem: {
    pssrId: 'ID DO PSSR',
    pssr: 'PSSR',
    moc: 'MOC',
    wo: 'WO',
    project: 'Projeto',
    teamLeads: 'L\u00ednder das Equipes',
    totalQuestions: 'Quest\u00f5es Totais',
    outstandingQuestions: 'Quest\u00f5es Pendentes',
    completedQuestions: 'Quest\u00f5es Completadas',
    area: '\u00c1rea',
    subArea: 'Sub \u00c1rea',
    facility: 'Facilidade',
    qaqcStatus: 'Status QAQC',
    qaqcMilestone: 'Marco QAQC',
    qaqcWorkOrder: 'Ordem de serviço QAQC',
    qaqcReady: '% pronto',
    qaqcComplete: '% concluído',
    qaqcAccepted: '% aceito',
    qaqcSignatures: 'Assinaturas',
    qaqcDocuments: 'Documentos QAQC',
    qaqcNoData: 'Sem dados QAQC',
  },
  pssrStatuses: {
    Draft: 'Rascunho',
    Initiated: 'iniciado',
    InProgress: 'Em andamento',
    Completed: 'Concluído',
    PendingApproval: 'Aprovação pendente',
    Approved: 'Aprovado',
    Closed: 'Fechado',
    Deleted: 'Excluído',
    CreateDate: 'Rascunho Criado em',
    InitiatedOn: 'Iniciado',
    StartedOn: 'Iniciado',
    CompletedOn: 'Inspeção Concluída em',
    PendingApprovalOn: 'Aprovação Apresentada em',
    ApprovedOn: 'Aprovado em',
    ClosedOn: 'Fechado em',
    DeletedOn: 'Eliminado em',
    RestoredOn: 'Restaurado em',
  },
  signatureCaptureDialog: {
    title: 'Capturar Assinatura',
    confirm: 'confirmar',
    saveSuccess: 'Assinatura capturada com sucesso',
  },
  projectsList: {
    title: 'Projetos',
    table: {
      projectName: 'Nome do projeto',
      projectManager: 'Gerente de projeto',
      status: 'Status',
      completedTotalPssrs: 'Pssrs concluídos/total',
      actions: 'Ações',
      dateCreated: 'Data de criação',
    },
    statusLabels: {
      active: 'ativo',
      closed: 'fechado',
    },
    sort: {
      placeholder: 'Ordenar por',
      nameAsc: 'Nome (A-Z)',
      nameDesc: 'Nome (Z-A)',
      statusAsc: 'Status (Baixo a Alto)',
      statusDesc: 'Status (Alto a Baixo)',
      dateAsc: 'Data de Criação (Mais Antigo)',
      dateDesc: 'Data de Criação (Mais Recente)',
    },
    actions: {
      open: 'abrir',
      createProject: 'criar projeto',
    },
    projectSearch: 'Pesquisa de Projetos',
    showDeletedProjects: 'Mostrar Projetos Excluídos',
    searchPlaceholder: 'Pesquisar por nome',
    datePlaceholder: 'mm/dd/aaaa - mm/dd/aaaa',
    statusPlaceholder: 'selecione um',
    noProjects: 'Nenhum projeto disponível',
  },
  projectEdit: {
    title: 'Editar Projeto',
    projectName: 'Nome do Projeto',
    projectNamePlaceholder: 'Digite o nome do projeto',
    statusActive: 'ativo',
    statusClosed: 'fechado',
    statusDeleted: 'excluído',
    teamMembers: 'Membros da Equipe',
    addParticipant: 'adicionar participante',
    pssrCcc: 'PSSR/CCC',
    newPssr: 'Novo {{pssrTitle}}',
    noPssrCcc: 'Não há PSSR/CCCs associados a este projeto.',
    delete: 'excluir',
    markAsClosed: 'marcar como fechado',
    reopen: 'reabrir',
    confirmDelete: 'Tem certeza de que deseja excluir este projeto?',
    confirmDeleteHeader: 'Confirmar Exclusão',
    confirmDeletePssrs: 'Deseja também excluir todos os PSSRs associados a este projeto?',
    confirmDeletePssrsHeader: 'Excluir PSSRs?',
    deleteSuccess: 'Projeto excluído com sucesso',
    confirmMarkAsClosed: 'Tem certeza de que deseja marcar este projeto como fechado?',
    confirmMarkAsClosedHeader: 'Confirmar Marcar como Fechado',
    markedAsClosedSuccess: 'Projeto marcado como fechado com sucesso',
    confirmCloseProjectTitle: 'Confirmar Fechamento do Projeto',
    confirmCloseProjectDescription: 'Tem certeza de que deseja marcar este projeto como fechado?',
    confirmReopenProjectTitle: 'Confirmar Reabertura do Projeto',
    confirmReopenProjectDescription: 'Tem certeza de que deseja reabrir este projeto?',
    cannotCloseProjectDueOpenPSSRs: 'Não é possível fechar o projeto porque há PSSRs abertos.',
    projectUpdatedSuccessfully: 'Projeto atualizado com sucesso',
    loadNewQaqcItems: 'Carregar novos itens QAQC',
    qaqcItemsLoadedSuccessfully: 'Novos itens QAQC carregados com sucesso',
    qaqcItemsUpToDate: 'Os itens QAQC já estão atualizados',
    qaqcInputWarning: 'Preencha os campos QAQC obrigatórios antes de carregar novos itens: {{fields}}.',
    initiateAll: 'Iniciar todas as PSSRs',
    initiateAllTitle: 'Iniciar todas as PSSRs',
    initiateAllDescription: 'Deseja iniciar todas as PSSRs deste projeto?',
    initiateAllSuccess: 'Todas as PSSRs foram iniciadas com sucesso',
    initiateAllPartialError: 'Algumas PSSRs não puderam ser iniciadas:',
    projectReopenedSuccessfully: 'Projeto reaberto com sucesso',
    restorePssr: 'Restaurar',
    confirmRestoreProject: 'Tem certeza de que deseja restaurar este projeto?',
    confirmRestoreProjectHeader: 'Confirmar Restauração',
    restoreSuccess: 'Projeto restaurado com sucesso',
    deleteDialog: {
      title: 'Confirmar Exclusão do Projeto',
      confirmDeleteWithPssrs:
        'Esta ação resultará na exclusão deste projeto e de todos os PSSR envolvidos. Deseja prosseguir?',
      confirmDeleteWithoutPssrs: 'Deseja prosseguir?',
      deleteProjectAndPssrs: 'Excluir Projeto e PSSRs',
      deleteProjectOnly: 'Excluir Apenas o Projeto',
      deleteSuccess: 'Projeto excluído com sucesso',
      deleteError: 'Erro ao excluir projeto',
    },
    cascadeDialog: {
      cascade: 'cascata',
      title: 'Funções em Cascata',
      description: 'Selecione os participantes que você deseja aplicar em cascata para todos os PSSRs deste projeto.',
      teamLeads: 'Líderes de Equipe',
      teamMembers: 'Membros da Equipe',
      operationsRepresentative: 'Representante de Operações',
      finalApprover: 'Aprovador Final',
      apply: 'aplicar',
      success: 'Funções aplicadas em cascata com sucesso',
    },
    errors: {
      noPermissionToEditParticipants: 'Você não tem permissão para editar participantes neste projeto',
    },
  },
  multiselect: {
    selectedItems: '{0} itens selecionados',
    placeholder: 'escolher',
  },
  support: {
    title: 'Feedback',
    buSupportInfo: 'Informações de Suporte BU ePSSR',
    serviceNowInstructions: 'Instruções de Emissão de Tickets ePSSR Service Now',
    instructions: {
      step1:
        'Vá ao formulário de <a class="support-link" href="https://chevron.service-now.com/mychevron?id=sc_cat_item_guide&sys_id=9c08a21edb126450182e1dca48961981&sysparm_u_appid=1500000886" target="_blank" rel="noopener">Solicitação de Suporte de Aplicação</a> no Portal de Serviços de TI da Chevron',
      step1LinkText: 'Solicitação de Suporte de Aplicação',
      step2: 'No campo Aplicação, selecione <b>Mobile PSSR</b>.',
      step3:
        'Para relatar um problema ou erro, selecione <b>Relatar um Problema</b>. Para enviar uma solicitação de melhoria ou acesso de usuário, selecione <b>Solicitação de Serviço</b>. Clique em Próximo.',
    },
    reportIssue: {
      title: 'Relatar um Problema',
      step1: 'Preencha a Descrição do Problema, Impacto e Urgência.',
      step2: 'Pressione Próximo e depois Enviar.',
      step3: 'A Equipe de Suporte ePSSR confirmará o recebimento do ticket em 24 horas durante o horário comercial.',
    },
    enhancement: {
      title: 'Solicitação de Melhoria',
      step1: 'Por favor, selecione <b>Melhorias</b> em Tipo de Solicitações.',
      step2: 'Selecione a Prioridade (<b>Baixa, Moderada, Alta</b>)',
      step3: 'Preencha a Descrição da Solicitação',
      step4: 'Selecione Próximo e Enviar.',
      step5:
        'A Equipe de Suporte ePSSR revisará as solicitações de melhoria como parte do Processo de Planejamento PI da Surface Digital',
    },
    userAccess: {
      title: 'Solicitação de Acesso de Usuário',
      step1: 'Por favor, selecione <b>Solicitar Acesso</b> em Tipo de Solicitações.',
      step2: 'Selecione o Tipo de Solicitação de Acesso (<b>Adicionar ou Remover</b>)',
      step3: 'Selecione um usuário',
      step4: 'Selecione a Prioridade (<b>Baixa, Moderada, Alta</b>)',
      step5: 'Especifique a Função e o Acesso que o Usuário precisa.',
      step6: 'Selecione Próximo e Enviar.',
      step7: 'A Equipe de Suporte ePSSR confirmará o recebimento do ticket em 24 horas durante o horário comercial.',
    },
  },
  datepicker: {
    dayNames: ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado'],
    dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
    dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
    monthNames: [
      'Janeiro',
      'Fevereiro',
      'Março',
      'Abril',
      'Maio',
      'Junho',
      'Julho',
      'Agosto',
      'Setembro',
      'Outubro',
      'Novembro',
      'Dezembro',
    ],
    monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
    today: 'Hoje',
    clear: 'Limpar',
    dateFormat: 'mm/dd/yy',
    weekHeader: 'Sm',
  },
  errors: {
    unauthorized: {
      title: 'Acesso não autorizado',
      message: 'Você não tem permissão para acessar esta página.',
    },
    serverError: {
      title: 'Erro do servidor',
      message: 'Ocorreu um erro inesperado. Tente novamente mais tarde.',
    },
    pageNotFound: {
      title: 'Página não encontrada',
      message: 'A página que você está procurando não existe.',
    },
    actions: {
      returnHome: 'Voltar para a página inicial',
    },
  },
  attachments: {
    sections: {
      images: 'Imagens',
      documents: 'Documentos',
      links: 'Links',
    },
    actions: {
      download: 'Baixar',
      delete: 'Excluir',
    },
    labels: {
      uploaded: 'Enviado',
    },
  },
  imagePreview: {
    errorMessage: 'Falha ao carregar a imagem',
    errorDetails: 'Verifique o console do navegador para mais detalhes',
  },
  functionalReview: {
    audit: {
      createdBy: 'Criado por',
      updatedDate: 'Data de atualização',
      updatedBy: 'Atualizado por',
    },
  },
  checklistItem: {
    toolbar: {
      bold: 'Negrito',
      italic: 'Itálico',
      underline: 'Sublinhado',
      orderedList: 'Lista ordenada',
      unorderedList: 'Lista não ordenada',
      codeBlock: 'Bloco de código',
      blockQuote: 'Citação em bloco',
    },
    alignment: {
      center: 'centralizado',
      right: 'direita',
      justify: 'justificado',
    },
  },
  pssrSections: {
    actions: {
      removeUser: 'Remover usuário',
    },
  },
  pssrParticipantsSections: {
    actions: {
      remove: 'Remover',
    },
  },
  progressBar: {
    label: 'Progresso:',
  },
  categories: {
    dialogs: {
      addCategory: 'Adicionar categoria',
      editCategory: 'Editar categoria',
      createSubCategory: 'Criar nova subcategoria',
      editSubCategory: 'Editar subcategoria',
    },
    placeholders: {
      subcategoryName: 'Nome da subcategoria',
    },
  },
  categoriesList: {
    title: 'Categorias',
    hideInactiveItems: 'Ocultar itens inativos',
    subCategoryName: 'Nome da subcategoria',
    inactive: '(inativo)',
    noSubcategories: 'Sem subcategorias',
    selectHeader: 'Selecionar',
    actions: {
      createSubCategory: 'Criar nova subcategoria',
      restore: 'Restaurar',
      add: 'Adicionar',
      addSubCategories: 'Adicionar subcategorias',
      remove: 'Remover',
    },
    deleteDisabledTooltip: 'Esta categoria não pode ser excluída porque contém subcategorias ativas',
    dialogs: {
      addSubCategoriesHeader: 'Adicionar subcategorias',
      deleteCategoryHeader: 'Atenção',
      deleteCategoryMessage: 'Tem certeza de que deseja excluir a Categoria: [{{name}}]?',
      deleteSubCategoryHeader: 'Atenção',
      deleteSubCategoryMessage: 'Remover [{{name}}] da categoria [{{category}}]? A subcategoria em si não será excluída.',
    },
    validation: {
      subCategoryExists: 'Já existe uma subcategoria com esse nome',
      categoryExists: 'Já existe uma categoria com esse nome',
    },
  },
};
export default pt;
